import { render, staticRenderFns } from "./HomeDesktop.vue?vue&type=template&id=53f6a4c6&scoped=true&"
import script from "./HomeDesktop.vue?vue&type=script&lang=js&"
export * from "./HomeDesktop.vue?vue&type=script&lang=js&"
import style0 from "./HomeDesktop.vue?vue&type=style&index=0&id=53f6a4c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.1_css-loader@1.0.1_webpack@4.46.0__handlebars@4.7.7_lodash@4.17.21_vue-templ_mtpkf7urruevj4gqqv3dlwyrx4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f6a4c6",
  null
  
)

export default component.exports